import React, { Component } from "react";
import "font-awesome/css/font-awesome.min.css";
import setIcon from "../images/settings.svg";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "../aboutTataCliq/AboutCLiQ.css";
import "./trainingCentre.css";
import ppt2 from "../ppt/OrderProcessing.ppt";
import OPVideo from "./video/video";
class OrderProcess extends Component {
  render() {
    return (
      <div className="main-container">
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="left-bar rounded h-100">
                <ul>
                  <li>
                    <Link to="/experiencezone/order-processing"
                      className="active"
                    >
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Order Processing</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/experiencezone/packaging-information">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Packaging Information</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/experiencezone/customer-returns">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Customer Returns</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-9">
              <div className="inner-content">
                <h1>Order Processing</h1>
                <p>
                  This course will provide the order processing procedure for
                  Ship from Store and CLiQ and Collect orders.
                </p>
                <div className="abtInnerVideo">
                  <OPVideo />
                </div>
                <p>
                  This course will provide the order processing procedure for
                  Ship from Store and CLiQ and Collect orders.
                </p>
                <form method="get" action={ppt2} target="_blank">
                  <button type="submit" className="download-btn">
                    Download for more info
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderProcess;
